import Vue from 'vue';
import { setDatadogUser } from 'library/helpers/tracing';
let instance;
/** Returns the current instance of the auth plugin */
export const getInstance = () => instance;
// eslint-disable-next-line
export const appConstantSetup = () => {
  if (instance) return instance;
  instance = new Vue({
    data() {
      return {
        appConstantDataIsLoading: false,
      };
    },
    created() {
      this.getAppConstants();
    },
    methods: {
      getAppConstants() {
        this.appConstantDataLoading = true;
        fetch('/dvsvc/appconstants?format=json')
          .then(async (resp) => {
            const json = await resp.json();
            if (resp.status === 200) {
              if (json?.UserGuid) {
                localStorage.setItem('dv-user-guid', json.UserGuid);
              }
              // Update Datadog user information
              this.updateDatadogUser(json);
              this.dataInitialized = true;
              this.setData(json);
            }
          })
          .finally(() => {
            this.authLoading = false;
          });
      },
      setData(json) {
        this.appConstantDataIsLoading = false;
        for (let key of Object.keys(json)) {
          this[key] = json[key];
        }
      },
      updateDatadogUser(appConstantData) {
        // Update Datadog with user information from AppConstants
        const userId = appConstantData.UserGuid;
        const userInfo = {
          UserName: appConstantData.UserName,
          ScoutName: appConstantData.ScoutName,
          ImAProxyLogin: appConstantData.ImAProxyLogin,
        };
        
        setDatadogUser(userId, userInfo);
      },
    },
  });
  return instance;
};
// Create a simple Vue plugin to expose the wrapper object throughout the application
export const AppConstantPlugin = {
  install(Vue) {
    Vue.prototype.$appConstants = appConstantSetup();
  },
};
